import axios from 'axios';

import authUtils from './auth';

import config from './config';

const BFF_URL = config('BFF_URL');
const X_API_KEY = config('API_GATEWAY_API_KEY');

export async function uploadBulkVouchers(formData) {
  const authToken = await authUtils.getAccessToken();

  await axios.post(`${BFF_URL}/bulk-vouchers/upload`, formData, {
    headers: {
      'x-api-key': X_API_KEY,
      Authorization: `Bearer ${authToken}`
    }
  });
}

export async function downloadBulkVouchers(filename) {
  const authToken = await authUtils.getAccessToken();

  const response = await axios.get(`${BFF_URL}/bulk-vouchers/download/${filename}`, {
    headers: {
      'x-api-key': X_API_KEY,
      Authorization: `Bearer ${authToken}`
    }
  });

  const fileBlob = new Blob([response.data], { type: response.data.type });

  const fileURL = window.URL.createObjectURL(fileBlob);

  const link = document.createElement('a');
  link.href = fileURL;
  link.download = filename;

  link.click();

  window.URL.revokeObjectURL(fileURL);
}
